// Configuración centralizada de la aplicación
export const config = {
  api: {
    baseUrl: import.meta.env.VITE_API_URL || 'https://control.seprovinsa.com/api.php',
    version: import.meta.env.VITE_API_VERSION || 'v1',
    timeout: 30000, // 30 segundos
  },
  app: {
    name: import.meta.env.VITE_APP_NAME || 'SEPROVINSA Control',
    version: import.meta.env.VITE_APP_VERSION || '3.0.0',
    environment: import.meta.env.VITE_ENV || 'production',
  },
  features: {
    analytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    errorTracking: import.meta.env.VITE_ENABLE_ERROR_TRACKING === 'true',
  },
  ui: {
    itemsPerPage: 20,
    imageLoadingPlaceholder: '/placeholder.png',
    defaultAvatar: '/default-avatar.png',
  },
} as const;

export default config;
